import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSubtasksEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-subtasks-edit',
	path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa',
};
